import { Skel } from "./ui";

interface SkeletonLoaderProps {
  type?: "page" | "card" | "list" | "detail";
  count?: number;
}

export function SkeletonLoader({ type = "page", count = 1 }: SkeletonLoaderProps) {
  if (type === "page") {
    return (
      <div className="page-wrap">
        {/* Hero carousel skeleton */}
        <Skel h={540} radius="var(--radius-xl)" style={{ marginBottom: 14 }} />
        
        {/* Promo strip skeleton */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 14, marginBottom: 52 }}>
          {[0, 1, 2].map((i) => (
            <Skel key={i} h={72} radius="var(--radius-md)" />
          ))}
        </div>
        
        {/* Section headers and cards skeleton */}
        {[0, 1, 2, 3, 4].map((section) => (
          <div key={section} style={{ marginBottom: 52 }}>
            <Skel h={18} w={160} style={{ marginBottom: 18 }} />
            <div style={{ display: "flex", gap: 14, overflow: "hidden" }}>
              {Array.from({ length: 7 }).map((_, i) => (
                <div key={i} style={{ flexShrink: 0, width: 168 }}>
                  <Skel h={224} radius="var(--radius-md) var(--radius-md) 0 0" />
                  <Skel h={72} radius="0 0 var(--radius-md) var(--radius-md)" style={{ marginTop: 0 }} />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (type === "card") {
    return (
      <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} style={{ flexShrink: 0, width: 168 }}>
            <Skel h={224} radius="var(--radius-md) var(--radius-md) 0 0" />
            <Skel h={72} radius="0 0 var(--radius-md) var(--radius-md)" style={{ marginTop: 0 }} />
          </div>
        ))}
      </div>
    );
  }

  if (type === "list") {
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} style={{ display: "flex", gap: 14, alignItems: "center" }}>
            <Skel h={60} w={80} radius="var(--radius-sm)" />
            <div style={{ flex: 1 }}>
              <Skel h={16} w="60%" style={{ marginBottom: 8 }} />
              <Skel h={12} w="40%" />
            </div>
            <Skel h={20} w={60} radius="var(--radius-sm)" />
          </div>
        ))}
      </div>
    );
  }

  if (type === "detail") {
    return (
      <div style={{ display: "grid", gridTemplateColumns: "1fr 300px", gap: 40 }}>
        <div>
          <Skel h={400} radius="var(--radius-xl)" style={{ marginBottom: 24 }} />
          <Skel h={24} w="70%" style={{ marginBottom: 12 }} />
          <Skel h={16} w="50%" style={{ marginBottom: 20 }} />
          <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
            {[0, 1, 2, 3].map((i) => (
              <Skel key={i} h={32} w={80} radius="var(--radius-sm)" />
            ))}
          </div>
          <Skel h={120} style={{ marginBottom: 24 }} />
        </div>
        <div>
          <Skel h={200} radius="var(--radius-lg)" style={{ marginBottom: 16 }} />
          <Skel h={40} w="100%" radius="var(--radius-sm)" style={{ marginBottom: 12 }} />
          <Skel h={40} w="100%" radius="var(--radius-sm)" />
        </div>
      </div>
    );
  }

  return <Skel h={200} />;
}
